import Typography from '@mui/material/Typography/Typography'
import { dayToJSDate } from 'components-ui/src/shared/dates'
import format from 'date-fns/esm/format'
import { WaitlistOrderClientDto } from 'service-api/src/types/api'
import { getPrimaryOfferDates } from '../helper'

type WaitlistInvoice = NonNullable<WaitlistOrderClientDto['invoices']>[number]

interface Props {
  order: WaitlistOrderClientDto
  invoice?: WaitlistInvoice
}

export const VisitDate = ({ order, invoice }: Props) => {
  const primarySt = order.primaryServiceType?.serviceType
  if (!primarySt) return

  const dates = invoice ?? getPrimaryOfferDates(order, order.primaryServiceType?.id || '')
  if (!dates?.startDate) return null

  const startDateStr = dayToJSDate(dates.startDate)
  if (!startDateStr) return null

  const startDate = format(new Date(startDateStr), 'MMM dd')
  if (!primarySt.overnight) return <Typography variant="subtitle2">{startDate}</Typography>

  const endDateStr = dayToJSDate(dates.endDate)
  if (!endDateStr) return null

  const endDate = format(new Date(endDateStr), 'MMM dd')

  return <Typography variant="subtitle2">{`${startDate} - ${endDate}`}</Typography>
}
